var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-caption"},_vm._l((_vm.textList),function(item,index){return _c('label',{key:index,class:item.type === 'bold' && 'font-weight-black'},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }